import { ServiceTypes } from 'constants/ServiceTypes';
import { IPlaneConfiguration } from 'interfaces/session/IStrikeZonePlaneConfiguration';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useInjection } from 'services/ioc/ioc.react';
import { LineupStore } from 'stores/LineupStore';
import { PlaneAdjustment } from './PlaneAdjustment';
import { IPlaneDefinition } from './planeDefinitions';
import { PlaneDescription, PlaneHeader, PlaneLabel, PlaneWrapper, StyledCheckbox } from './StrikeZoneCalculationStyles';

interface IProps {
  definition: IPlaneDefinition;
  plane: IPlaneConfiguration;
}

export const PlaneRow: React.FC<IProps> = observer((props) => {
  const { definition, plane } = props;
  const lineupStore = useInjection<LineupStore>(ServiceTypes.LineupStore);

  return (
    <PlaneWrapper>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <StyledCheckbox
          label=''
          checked={plane.isEnabled}
          reversed
          withoutBorder
          onChange={() => lineupStore.togglePlane(definition.locationType)}
          data-testid={`plane-${definition.testId}-checkbox`}
        />
        <PlaneHeader>
          <PlaneLabel>{definition.label}</PlaneLabel>
          <PlaneDescription>{definition.description}</PlaneDescription>
        </PlaneHeader>
      </div>
      {definition.hasAdjustments && plane.isEnabled && (
        <>
          <PlaneAdjustment
            locationType={definition.locationType}
            kind='offset'
            toggleLabel='Add a height offset to the section'
            inputLabel='Offset'
            isEnabled={plane.isOffsetEnabled}
            valueInInches={plane.offsetY}
            onToggle={lineupStore.setPlaneAdjustmentEnabled}
            onValueChange={lineupStore.setPlaneAdjustmentValue}
            testIdPrefix={`plane-${definition.testId}-offset`}
          />
          <PlaneAdjustment
            locationType={definition.locationType}
            kind='extension'
            toggleLabel='Add an extension to the bottom of the section'
            inputLabel='Extension'
            isEnabled={plane.isExtensionEnabled}
            valueInInches={plane.extension}
            onToggle={lineupStore.setPlaneAdjustmentEnabled}
            onValueChange={lineupStore.setPlaneAdjustmentValue}
            testIdPrefix={`plane-${definition.testId}-extension`}
          />
        </>
      )}
    </PlaneWrapper>
  );
});
